/**
 * GENERATED CODE – DO NOT EDIT!
 */
/* eslint-disable */
import * as $protobuf from 'protobufjs/light';
import { fixType } from '../../Fixes';
import Builder from '../../Builder';
import '../common/currency';
import '../common/time';
import '../paymentbalances/external_sources';
import './detail';
const $root = $protobuf.roots['default'] || ($protobuf.roots['default'] = new $protobuf.Root());
const jsonData = {
  "squareup": {
    "nested": {
      "ledger": {
        "nested": {
          "LedgerEntry": {
            "fields": {
              "token": {
                "type": "string",
                "id": 1,
                "rule": "optional"
              },
              "merchantToken": {
                "type": "string",
                "id": 3,
                "rule": "optional"
              },
              "paymentToken": {
                "type": "string",
                "id": 5,
                "rule": "optional"
              },
              "entryType": {
                "type": ".squareup.ledger.LedgerEntry.Type",
                "id": 7,
                "rule": "optional"
              },
              "toUserAmount": {
                "type": ".squareup.common.Money",
                "id": 9,
                "rule": "optional"
              },
              "toFeeAccountAmount": {
                "type": ".squareup.common.Money",
                "id": 10,
                "rule": "optional"
              },
              "effectiveAt": {
                "type": ".squareup.common.time.DateTime",
                "id": 11,
                "rule": "optional"
              },
              "transactionFundId": {
                "type": "int64",
                "id": 15,
                "rule": "optional"
              },
              "createdAt": {
                "type": ".squareup.common.time.DateTime",
                "id": 16,
                "rule": "optional"
              },
              "externalSource": {
                "type": ".squareup.paymentbalances.ExternalSource",
                "id": 17,
                "rule": "optional"
              },
              "detail": {
                "type": ".squareup.ledger.LedgerEntryDetail",
                "id": 20,
                "rule": "optional"
              },
              "rootLedgerEntry": {
                "type": ".squareup.ledger.LedgerEntry",
                "id": 21,
                "rule": "optional"
              },
              "isTestLedgerEntry": {
                "type": "bool",
                "id": 22,
                "rule": "optional",
                "options": {
                  "default": false
                }
              }
            },
            "nested": {
              "Type": {
                "values": {
                  "INITIAL_BALANCE_CHANGE": 31,
                  "UNDO": 32,
                  "CAPTURE": 1,
                  "REFUND": 2,
                  "ADJUSTMENT": 3,
                  "REDEMPTION": 4,
                  "HOLD": 5,
                  "RELEASE": 6,
                  "UNDO_HOLD": 7,
                  "UNDO_RELEASE": 8,
                  "PAYOUT": 9,
                  "INCENTED_PAYMENT": 10,
                  "BANK_BALANCE_ADJUSTMENT": 11,
                  "MCA_REPAYMENT": 12,
                  "MCA_REPAYMENT_REFUND": 13,
                  "MCA_ADVANCE": 14,
                  "LEGACY_RETURNED_PAYOUT": 15,
                  "SQUARE_PLUS": 16,
                  "RETURNED_SQUARE_PLUS": 17,
                  "LEGACY_ABORTED_PAYOUT": 18,
                  "LEGACY_ACH_TRANSFER": 19,
                  "LEGACY_CORRECTION": 20,
                  "LEGACY_GUARANTEED_PAYMENT": 21,
                  "LEGACY_RETURNED_ACH_ENTRY": 22,
                  "LEGACY_SEED": 23,
                  "LEGACY_TRANSFER": 24,
                  "RETURNED_LEDGER_ENTRY": 25,
                  "FREE_PROCESSING_ADJUSTMENT": 27,
                  "LEGACY_BALANCE_CAPTURE": 28,
                  "LEGACY_BALANCE_REFUND": 29,
                  "SUBSCRIPTION_FEE": 26,
                  "SUBSCRIPTION_FEE_REFUND": 30,
                  "SUBSCRIPTION_FEE_PAID_REFUND": 37,
                  "TAX_ON_FEE": 33,
                  "CAPITAL_FIXED_DEPOSIT": 34,
                  "CAPITAL_FIXED_PAYMENT": 35,
                  "UNDO_TAX_ON_FEE": 36,
                  "OPEN_DISPUTE": 38,
                  "DISPUTE_ADJUSTMENT": 39,
                  "RESOLVED_DISPUTE": 40,
                  "FEE": 41,
                  "UNDO_FEE": 42,
                  "BALANCE_TENDER": 43,
                  "THIRD_PARTY_FEE": 44,
                  "THIRD_PARTY_FEE_REFUND": 47,
                  "MONEY_TRANSFER": 45,
                  "MONEY_TRANSFER_REVERSAL": 46,
                  "ESCHEATMENT": 48,
                  "CAPITAL_PROMOTION_BONUS": 49,
                  "BOOKKEEPER_ADJUSTMENT": 50,
                  "APP_FEE_REVENUE": 51,
                  "APP_FEE_REFUND": 52,
                  "RISK_RESERVE_HOLD": 53,
                  "RISK_RESERVE_RELEASE": 54,
                  "RECOVERY_OFFSET_ADJUSTMENT": 55,
                  "UNLINKED_REFUND": 56,
                  "UNDO_UNLINKED_REFUND": 57,
                  "SQUARE_CARD_TRANSFER": 58,
                  "SFS_SAVINGS_TRANSFER": 59,
                  "INVEST_TRANSFER": 60,
                  "CAPITAL_CREDIT_CARD_TRANSFER": 61,
                  "CAPITAL_LOAN_TRANSFER": 62,
                  "MANUAL_TRANSFER": 63,
                  "BANKING_FOLDERS_TRANSFER": 64,
                  "LOCAL_OFFERS_CASHBACK_TRANSFER": 65,
                  "LOCAL_OFFERS_FEE_TRANSFER": 66,
                  "CASH_FOR_BUSINESS_TRANSFER": 67,
                  "CASH_FOR_BUSINESS_FEE_REFUND": 68,
                  "CASH_FOR_BUSINESS_DISPUTE": 69,
                  "GIFT_CARD_POOL_TRANSFER": 70,
                  "PERCENTAGE_PROCESSING_ENROLLMENT": 71,
                  "PERCENTAGE_PROCESSING_REPAYMENT": 72,
                  "PERCENTAGE_PROCESSING_DEACTIVATION": 73,
                  "PROCESSING_FEE": 74,
                  "PROCESSING_FEE_REFUND": 75,
                  "UNDO_PROCESSING_FEE_REFUND": 76,
                  "GIFT_CARD_LOAD_FEE": 77,
                  "GIFT_CARD_LOAD_FEE_REFUND": 78,
                  "UNDO_GIFT_CARD_LOAD_FEE_REFUND": 79,
                  "DEPOSIT_FEE": 80,
                  "SQUARE_PAYROLL_TRANSFER": 81,
                  "CHECK_ISSUED": 82,
                  "DELIVERY_REIMBURSEMENT": 83,
                  "BITCOIN_CONVERSION_TRANSFER": 84,
                  "LINE_OF_CREDIT_REPAYMENT": 85,
                  "BITCOIN_SELL_PROCEEDS": 86,
                  "BITCOIN_BUY_TRANSFER": 87,
                  "EMPLOYEE_TIP_PAYMENT": 88,
                  "EMPLOYEE_TIP_PAYMENT_REFUND": 89
                }
              }
            }
          },
          "SettlementFrequency": {
            "values": {
              "DO_NOT_USE": 0,
              "DAILY": 1,
              "WEEKDAY": 2,
              "WEEKLY": 3
            }
          },
          "BalanceTypeAmounts": {
            "fields": {
              "nextDeposit": {
                "type": ".squareup.ledger.PendingDeposit",
                "id": 1,
                "rule": "optional"
              },
              "outstandingAmount": {
                "type": ".squareup.common.Money",
                "id": 2,
                "rule": "optional"
              },
              "outstandingDebitAmount": {
                "type": ".squareup.common.Money",
                "id": 3,
                "rule": "optional"
              },
              "transactionFundId": {
                "type": "int32",
                "id": 4,
                "rule": "optional"
              },
              "defaultBalanceDetail": {
                "type": ".squareup.ledger.BalanceTypeAmounts.DefaultBalanceDetail",
                "id": 5
              },
              "feeBalanceDetail": {
                "type": ".squareup.ledger.BalanceTypeAmounts.FeeBalanceDetail",
                "id": 6
              }
            },
            "nested": {
              "DefaultBalanceDetail": {
                "fields": {}
              },
              "FeeBalanceDetail": {
                "fields": {}
              },
              "balance_detail": {
                "oneof": ["defaultBalanceDetail", "feeBalanceDetail"]
              }
            }
          },
          "PendingDeposit": {
            "fields": {
              "token": {
                "type": "string",
                "id": 6,
                "rule": "optional"
              },
              "amount": {
                "type": ".squareup.common.Money",
                "id": 1,
                "rule": "optional"
              },
              "debitAmount": {
                "type": ".squareup.common.Money",
                "id": 2,
                "rule": "optional"
              },
              "settleAt": {
                "type": ".squareup.common.time.DateTime",
                "id": 3,
                "rule": "optional"
              },
              "transactionFundId": {
                "type": "int32",
                "id": 4,
                "rule": "optional"
              },
              "ledgerEntry": {
                "type": ".squareup.ledger.LedgerEntry",
                "id": 5,
                "rule": "repeated"
              },
              "active": {
                "type": "bool",
                "id": 7,
                "rule": "optional"
              },
              "effectiveAt": {
                "type": ".squareup.common.time.DateTime",
                "id": 8,
                "rule": "optional"
              }
            }
          },
          "PotentialDepositSchedule": {
            "fields": {
              "requestedCutoffAt": {
                "type": ".squareup.common.time.LocalTime",
                "id": 1,
                "rule": "optional"
              },
              "depositSchedule": {
                "type": ".squareup.ledger.DepositSchedule",
                "id": 2,
                "rule": "optional"
              }
            }
          },
          "DepositSchedule": {
            "fields": {
              "effectiveAt": {
                "type": ".squareup.common.time.DateTime",
                "id": 1,
                "rule": "optional"
              },
              "interval": {
                "type": ".squareup.ledger.DepositInterval",
                "id": 2,
                "rule": "repeated"
              },
              "timezone": {
                "type": "string",
                "id": 3,
                "rule": "optional"
              },
              "settleIfOptional": {
                "type": "bool",
                "id": 4,
                "rule": "optional"
              }
            }
          },
          "DepositInterval": {
            "fields": {
              "cutoffAt": {
                "type": ".squareup.common.time.DayTime",
                "id": 1,
                "rule": "optional"
              },
              "initiateAt": {
                "type": ".squareup.common.time.DayTime",
                "id": 2,
                "rule": "optional"
              },
              "sameDaySettlementEnabled": {
                "type": "bool",
                "id": 3,
                "rule": "optional"
              }
            }
          },
          "LedgerEntrySummary": {
            "nested": {
              "Payments": {
                "nested": {
                  "Payment": {
                    "fields": {
                      "paymentToken": {
                        "type": "string",
                        "id": 1,
                        "rule": "optional"
                      },
                      "paymentTakenAt": {
                        "type": ".squareup.common.time.DateTime",
                        "id": 2,
                        "rule": "optional"
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
};

// Do not initialize these protos if they have already been defined
if (!$root.nested?.squareup?.nested?.ledger?.nested?.LedgerEntry && !$root.nested?.squareup?.nested?.ledger?.nested?.LedgerEntry?.nested?.Type && !$root.nested?.squareup?.nested?.ledger?.nested?.SettlementFrequency && !$root.nested?.squareup?.nested?.ledger?.nested?.BalanceTypeAmounts && !$root.nested?.squareup?.nested?.ledger?.nested?.BalanceTypeAmounts?.nested?.DefaultBalanceDetail && !$root.nested?.squareup?.nested?.ledger?.nested?.BalanceTypeAmounts?.nested?.FeeBalanceDetail && !$root.nested?.squareup?.nested?.ledger?.nested?.PendingDeposit && !$root.nested?.squareup?.nested?.ledger?.nested?.PotentialDepositSchedule && !$root.nested?.squareup?.nested?.ledger?.nested?.DepositSchedule && !$root.nested?.squareup?.nested?.ledger?.nested?.DepositInterval && !$root.nested?.squareup?.nested?.ledger?.nested?.LedgerEntrySummary?.nested?.Payments?.nested?.Payment) {
  $root.addJSON(jsonData);
}

/**
 * A ledger entry.
 *
 * SOURCE LedgerEntry @ squareup/ledger/ledger.proto at 23:1
 */
export const LedgerEntry = $root.lookupType('squareup.ledger.LedgerEntry');
fixType(LedgerEntry);
Builder.createAndAttachToType(LedgerEntry);
/**
 * DO NOT CHANGE THE NAMES OF THE ENUMS
 *
 * SOURCE Type @ squareup/ledger/ledger.proto at 25:3
 */
LedgerEntry.Type = $root.lookupEnum('squareup.ledger.LedgerEntry.Type').values;
/**
 * The frequency at which the merchant is to be settled
 *
 * SOURCE SettlementFrequency @ squareup/ledger/ledger.proto at 866:1
 */
export const SettlementFrequency = $root.lookupEnum('squareup.ledger.SettlementFrequency').values;
/**
 * The amounts for a given type of balance belonging to a merchant, e.g. their Cost+ balance.
 * The amounts for all balance types added together constitute the merchant's pending balance.
 *
 * SOURCE BalanceTypeAmounts @ squareup/ledger/ledger.proto at 1191:1
 */
export const BalanceTypeAmounts = $root.lookupType('squareup.ledger.BalanceTypeAmounts');
fixType(BalanceTypeAmounts, {
  outstandingAmount: {
    required: true
  },
  outstandingDebitAmount: {
    required: true
  },
  transactionFundId: {
    required: true
  }
});
Builder.createAndAttachToType(BalanceTypeAmounts);
/**
 * The amounts and cutoff time are for the default payment processing balance
 *
 * SOURCE DefaultBalanceDetail @ squareup/ledger/ledger.proto at 1214:3
 */
BalanceTypeAmounts.DefaultBalanceDetail = $root.lookupType('squareup.ledger.BalanceTypeAmounts.DefaultBalanceDetail');
fixType(BalanceTypeAmounts.DefaultBalanceDetail);
Builder.createAndAttachToType(BalanceTypeAmounts.DefaultBalanceDetail);
/**
 * The amounts and cutoff time are for the fee balance
 *
 * SOURCE FeeBalanceDetail @ squareup/ledger/ledger.proto at 1218:3
 */
BalanceTypeAmounts.FeeBalanceDetail = $root.lookupType('squareup.ledger.BalanceTypeAmounts.FeeBalanceDetail');
fixType(BalanceTypeAmounts.FeeBalanceDetail);
Builder.createAndAttachToType(BalanceTypeAmounts.FeeBalanceDetail);
/**
 * A potential deposit a merchant might receive. This becomes a BankSettlementEntry when the merchant
 * is settled. A PendingBalance is a collection of PendingDeposits.
 *
 * SOURCE PendingDeposit @ squareup/ledger/ledger.proto at 1268:1
 */
export const PendingDeposit = $root.lookupType('squareup.ledger.PendingDeposit');
fixType(PendingDeposit, {
  amount: {
    required: true
  },
  debitAmount: {
    required: true
  },
  settleAt: {
    required: true
  },
  transactionFundId: {
    required: true
  }
});
Builder.createAndAttachToType(PendingDeposit);
/**
 * The potential deposit schedule for a cutoff time
 *
 * SOURCE PotentialDepositSchedule @ squareup/ledger/ledger.proto at 1358:1
 */
export const PotentialDepositSchedule = $root.lookupType('squareup.ledger.PotentialDepositSchedule');
fixType(PotentialDepositSchedule);
Builder.createAndAttachToType(PotentialDepositSchedule);
/**
 * Deposit schedule for a week
 *
 * SOURCE DepositSchedule @ squareup/ledger/ledger.proto at 1391:1
 */
export const DepositSchedule = $root.lookupType('squareup.ledger.DepositSchedule');
fixType(DepositSchedule);
Builder.createAndAttachToType(DepositSchedule);
/**
 * Timing information about a settlement deposit
 *
 * SOURCE DepositInterval @ squareup/ledger/ledger.proto at 1420:1
 */
export const DepositInterval = $root.lookupType('squareup.ledger.DepositInterval');
fixType(DepositInterval);
Builder.createAndAttachToType(DepositInterval);
/**
 * Summary message containing useful aggregate information for a given bank settlement entry.
 *
 * SOURCE LedgerEntrySummary @ squareup/ledger/ledger.proto at 1513:1
 */
export const LedgerEntrySummary = {};
/**
 * SOURCE Payments @ squareup/ledger/ledger.proto at 1546:3
 */
LedgerEntrySummary.Payments = {};
/**
 * SOURCE Payment @ squareup/ledger/ledger.proto at 1551:5
 */
LedgerEntrySummary.Payments.Payment = $root.lookupType('squareup.ledger.LedgerEntrySummary.Payments.Payment');
fixType(LedgerEntrySummary.Payments.Payment);
Builder.createAndAttachToType(LedgerEntrySummary.Payments.Payment);